import { render } from "./Instrumentos.vue?vue&type=template&id=115dbfd6&scoped=true"
import script from "./Instrumentos.vue?vue&type=script&lang=js"
export * from "./Instrumentos.vue?vue&type=script&lang=js"

import "./Instrumentos.vue?vue&type=style&index=0&id=115dbfd6&scoped=true&lang=scss"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115dbfd6"]])

export default __exports__